/**
 * Alpine.js Speakers Language Switcher
 *
 * Lets users flip between their learning languages inside the
 * "{Language} Speakers" widget on the account/home page. Fetches a
 * freshly-rendered widget from /app/helpers/usersets and swaps the
 * content in place.
 */
export function speakersLanguageSwitcher(initialLang, layout = 'modern') {
    return {
        activeLang: (initialLang || '').toUpperCase(),
        layout: layout || 'modern',
        loading: false,
        error: false,
        menuOpen: false,

        openMenu() {
            this.menuOpen = true;
        },

        closeMenu() {
            this.menuOpen = false;
        },

        isActive(lang) {
            return this.activeLang === (lang || '').toUpperCase();
        },

        async switchTo(lang) {
            const code = (lang || '').toUpperCase();
            if (!code || this.loading || this.isActive(code)) return;

            const target = this.$refs.widget;
            if (!target) return;

            const previous = this.activeLang;
            this.activeLang = code;
            this.loading = true;
            this.error = false;

            try {
                const layoutParam = this.layout === 'legacy' ? '&layout=ultra-legacy' : '';
                const url = '/app/helpers/usersets?todo=lang&render=1&limit=20&lang=' + encodeURIComponent(code) + layoutParam;
                const response = await fetch(url, { credentials: 'include' });
                if (!response.ok) throw new Error('HTTP ' + response.status);
                const html = await response.text();

                target.innerHTML = html;

                if (window.Alpine && window.Alpine.initTree) {
                    window.Alpine.initTree(target);
                }
                if (window.LucideIcons) {
                    window.LucideIcons.initialize(target);
                } else if (window.lucide) {
                    window.lucide.createIcons({ parent: target });
                }
            } catch (e) {
                this.activeLang = previous;
                this.error = true;
            } finally {
                this.loading = false;
            }
        }
    };
}
